module.exports = __webpack_public_path__ + "01_glasses_black.31ce5f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/01_glasses_black.png
// module id = mwhN
// module chunks = 0